import * as React from 'react';

import Button from '../../Button';
import {Modal} from '../../Modal';
import './CloneDocumentModal.css';

export interface ICloneDocumentModalProps {
  show: any;
  onCloneDocument(name:string): any;
  onClose: any;
}

export interface ICloneDocumentModalState {
  cloneDocumentName: string;
}


export default class CloneDocumentModal extends React.Component<ICloneDocumentModalProps, ICloneDocumentModalState> {
  constructor(props: ICloneDocumentModalProps) {
    super(props);
    this.state = {
      cloneDocumentName: "",
    };
  }

  onHandleNameChange(text: string) {
    this.setState({
      cloneDocumentName: text
    });
  }

  render(){
    return (
    <Modal show={this.props.show} className="success-modal" onClose={this.props.onClose}>
      <Modal.Header>
        <Modal.Title>
          <h5>Clone Document</h5>
        </Modal.Title>
        <Button bsClass="close" onClick={()=> {this.props.onClose(), this.setState({cloneDocumentName: ""})}}></Button>
      </Modal.Header>
      <Modal.Body>
        <div className="coverInputContainer">
          <label>
            Enter New Name for Cloned Document (Optional)
          </label>
          <input
            className="coverModelInput"
            type="text"
            max={40}
            value={this.state.cloneDocumentName}
            onChange={(event) => this.onHandleNameChange(event.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={()=> {this.props.onClose(), this.setState({cloneDocumentName: ""})}}>
          Cancel
        </Button>
        <Button onClick={() => {this.props.onCloneDocument(this.state.cloneDocumentName), this.setState({cloneDocumentName: ""})}}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}}


// WEBPACK FOOTER //
// ./src/components/Modals/ClonedDocumentModal/CloneDocumentModal.tsx